const isBrowserIE = () => {
  return !!document.documentMode
}

export {
  isBrowserIE
}